import React from "react"

import VectorShape11 from "../../images/shape/vector-shape11.png"
import DynamicImage from "../common/DynamicImage";
import SectionTitle from "../common/SectionTitle";
import { getBackgroundClass } from "../../utils/sectionHelpers";

const WeServe = ({data}) => {
  const defaultIconMap = {
  FinTech: "flaticon-bitcoin",
  Healthcare: "flaticon-hospital",
  Education: "flaticon-distance-education",
};
const settings = data?.Settings || {};

    const backgroundClass = getBackgroundClass(settings.background);

  return (
    <>
      <section className={`industries-serve-area uiux-design pt-100 pb-70  ${backgroundClass}`}>
        <div className="container">
          {/* <div className="section-title">
            <h2>{data.title}</h2>
          </div> */}
          <SectionTitle data={data} />

          {/* <div className="row justify-content-center gy-4">
            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-bitcoin"></i>
                </div>
                FinTech

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-family-insurance"></i>
                </div>
                Municipal & Government

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-order"></i>
                </div>
                eCommerce

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-hospital"></i>
                </div>
                Healthcare

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-tracking"></i>
                </div>
                Logistics

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-distance-education"></i>
                </div>
                Education

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-factory"></i>
                </div>
                Energy & Power

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-factory"></i>
                </div>
                Manufacturing

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-house"></i>
                </div>
                Real Estate

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-tracking"></i>
                </div>
                Transport & Mobility

              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
              <div className="single-industries-serve-box">
                <div className="icon">
                  <i className="flaticon-laptop"></i>
                </div>
                ICT

              </div>
            </div>
          </div> */}
          <div className="row justify-content-center gy-4">
            {data?.industriesCard?.map((card) => (
              <div
                key={card.id}
                className="col-lg-3 col-sm-6 col-md-6"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="single-industries-serve-box">
                  <div className="icon">

                    {/* If Image Exists */}
                    {card?.image ? (
                      <DynamicImage image={card.image} />
                    ) : (
                      /* Default Icon */
                      <i className={defaultIconMap[card.title] || "flaticon-bitcoin"}></i>
                    )}

                  </div>

                  {card.title}

                </div>
              </div>
            ))}
          </div>
          <div className="row justify-content-center align-items-center mt-4" >
            <div className="col-lg-10 text-center">
              {data?.content?.map((block, index) => {
                    switch (block.type) {
                        case "paragraph":
                            return (
                                <p key={index} className="mb-0">
                                    {block.children.map((child, i) => {
                                        let textElement = child.text;

                                        if (child.bold) {
                                            textElement = <strong>{textElement}</strong>;
                                        }

                                        if (child.italic) {
                                            textElement = <em>{textElement}</em>;
                                        }

                                        if (child.underline) {
                                            textElement = <u>{textElement}</u>;
                                        }

                                        if (child.strikethrough) {
                                            textElement = <s>{textElement}</s>;
                                        }

                                        return <React.Fragment key={i}>{textElement}</React.Fragment>;
                                    })}
                                </p>

                            );

                        case "heading":
                            const Tag = `h${block.level}`;
                            return (
                                <Tag key={index} className="mt-4 mb-3">
                                    {block.children.map(c => c.text).join("")}
                                </Tag>
                            );

                        case "list":
                            return (
                                <ul key={index}>
                                    {block.children.map((item, i) => (
                                        <li key={i} >
                                                {item.children.map(c => c.text).join("")}
                                        </li>
                                    ))}
                                </ul>
                            );

                        default:
                            return null;
                    }
                })}
            </div>
          </div>

        </div>

        <div className="vector-shape11">
          <img src={VectorShape11} alt="Vector Shape" />
        </div>
      </section>
    </>
  )
}

export default WeServe
